import { Post } from "../core/Helper";

export class StudyTemplateService {
  static async GetTemplateList(params) {
    let result = await Post("api/template-result/get-template-list", params);
    return (await result) ?? null;
  }

  static async RemoveTemplate(params) {
    let result = await Post("api/template-result/remove-template", params);
    return (await result) ?? null;
  }
}
